import React, { useRef } from 'react';
import { Marker } from 'react-leaflet';

/**
 * A Marker that becomes draggable when editMode is true and fires
 * onDragEnd({ lat, lng }) once the user releases the marker.
 *
 * Used for any point a user should be able to reposition on a map:
 * surface / bottom-hole markers on a well's Map tab, and well location
 * markers on a tract's Map tab.
 */
export default function DraggableMarker({
    position,
    editMode = false,
    onDragEnd,
    icon,
    children,
}) {
    const ref = useRef(null);

    const handleDragEnd = (e) => {
        const layer = e?.target;
        if (!layer || typeof layer.getLatLng !== 'function') return;
        const ll = layer.getLatLng();
        if (onDragEnd) onDragEnd({ lat: ll.lat, lng: ll.lng });
    };

    // Only spread `icon` when the caller actually provides one. Passing
    // icon={undefined} explicitly trips react-leaflet 2.x — it tries to call
    // createIcon() on the undefined value instead of falling back to
    // L.Icon.Default. Omitting the prop entirely is what the rest of the app
    // does for default-icon markers.
    const iconProp = icon ? { icon } : {};

    return (
        <Marker
            position={position}
            draggable={!!editMode}
            ondragend={handleDragEnd}
            ref={ref}
            {...iconProp}
        >
            {children}
        </Marker>
    );
}
